import axios from "axios";
import noUiSlider from 'nouislider';
import '../assets/css/slider.css';
const siteURL = window.location.origin;

axios.defaults.headers = {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': '0',
  };
  
export default {
    name: "App",
    components: {},
    data: function() {
        return {
            product: {
                // eslint-disable-next-line no-undef
                id: passed_values.cs4_product_id,
                array: null,
                selected: {},
                initialUnitPrice: 0,
                initialQuantity: null,
            },
            input: {
                field: ""
            },
            icons: {
                crystal: `${siteURL}/wp-content/uploads/2019/07/Crystal@2x.png`,
                product: `${siteURL}/wp-content/uploads/2019/09/icon-follower@2x.png`,
                crossProduct: `${siteURL}/wp-content/uploads/2020/10/icon_cuore.svg`,
                confirm: `${siteURL}/wp-content/uploads/2019/09/checked@2x.png`
            },
            steps: {
                isFirst: true,
                isLoading: false,
                isAddingToCart: false,
                orderCompleted: false,
            },
            dictionary: {}
        };
    },
    methods: {
        getProductInfo: async function() {
            return axios.get(this.getProductApiURL()).then((res) => {
                this.product.array = res.data.sort(function(product1, product2) {
                    return product1.id < product2.id ? -1 : 1;
                });
            });
        },
        getProductApiURL: function() {
            return `https://api2.comprasocial.me/products/priceList/${this.product.id}`
        },
        getProductQuantity: function(productIndex, cleanFromDots = false) {
            if(productIndex){
                const res = this.product.array[productIndex].attributes.find((el) => el.name == "Quantità").option;
                return cleanFromDots ? res.replace('.','') : res;
            }
            if(this.product.selected && this.product.selected.attributes){
                const res = this.product.selected.attributes.find((el) => el.name == "Quantità").option;
                return cleanFromDots ?  res.replace('.','') : res;
            }
            return 0;
        },
        generateStarForReview: function(dictionary) {
            let givenRating = dictionary.reviewValue;
            let resHtml = `<strong>${givenRating}</strong> ${dictionary.on} 5 `;
            for(let count = 0; count < 5; count++) {
              if(givenRating >= 1){
                resHtml += `<img class="cs4-star" src="${dictionary.fullStarIcon}" alt="star">`
              } else if( givenRating >= 0.5 && givenRating < 1) {
                resHtml += `<img class="cs4-star" src="${dictionary.halfStarIcon}" alt="star">`
              } else {
                resHtml += `<img class="cs4-star" src="${dictionary.emptyStarIcon}" alt="star">`
              }
              givenRating--;
            }

            resHtml += `<div class="cs4-review-section__based-on"> ${dictionary.reviewTotalNumber} ${dictionary.reviewTotalLabel}</div> `;
            return resHtml;
        },
        getProductPrice: function(productIndex){
            if(productIndex){
                const product = this.product.array[productIndex];
                return  product.sale_price ? Number.parseFloat(product.sale_price).toFixed(2) :  Number.parseFloat(product.regular_price).toFixed(2);
            }
            if(this.product.selected && this.product.selected.regular_price) {
                return this.product.selected.sale_price ? Number.parseFloat(this.product.selected.sale_price).toFixed(2) :  Number.parseFloat(this.product.selected.regular_price).toFixed(2);
            }
            return 0.00.toFixed(2)
        },
        getProductCrystal: function(){
            return Math.floor(Number.parseFloat(this.getProductPrice()));
        },
        getProductDiscount: function(){
            const currentProductUnitPrice = this.getProductPrice() / this.getProductQuantity(null, true);
            const decrease = ((this.product.initialUnitPrice - currentProductUnitPrice) / this.product.initialUnitPrice ) * 100;
            return decrease > 0 ? `${this.dictionary.discountLabel}: - ${Number.parseInt(decrease)}%` : '';
        },
        setSlider: function(){
            var slider = document.getElementById('cs4-productSlider');
            noUiSlider.create(slider, {
                start: [0],
                range: {
                    'min': 0,
                    'max': this.product.array.length - 1
                },
                connect: "lower",
                tooltips: {to: (sliderValue) => {
                        const index = Math.round(sliderValue);
                        this.product.selected = this.product.array[index];
                        return `<img class="cs4-product-icon" src="${this.dictionary.iconProduct}"/> +${this.getProductQuantity()}`
                    }},
                step: 1
            });
        },
        increaseCartItemCounter() {
            const cartItemCounter = document.getElementById('cs-header__cartCounter');
            cartItemCounter.innerText = parseInt(cartItemCounter.innerText) + 1;
        },
        addProductToCart: async function() {
            if(this.input.field.replace(" ", "") === "") {
                const inputField = document.getElementById("inputField");
                inputField.classList.add("errorBounce");
                setTimeout(function(){
                    inputField.classList.remove("errorBounce");
                }, 1000)
            } else {
                this.steps.isLoading = true;
                this.steps.isFirst = false;
                this.steps.isAddingToCart = true;
                var productRequestFormData = new URLSearchParams();
                productRequestFormData.append('action','woocommerce_ajax_add_to_cart');
                productRequestFormData.append('product_id', this.product.selected.id);
                productRequestFormData.append('product_qty', 1);
                productRequestFormData.append('links', this.input.field);
                if(this.product.initialQuantity !== null){
                    productRequestFormData.append('initialQuantities', this.product.initialQuantity);
                }
                // eslint-disable-next-line no-undef
                await axios.post(wc_add_to_cart_params.ajax_url, productRequestFormData,{
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                });
                this.increaseCartItemCounter();
                this.steps.isLoading = false;
                this.steps.isAddingToCart = false;
                this.steps.orderCompleted = true;
                this.product.selected = this.product.array[0];
                this.input.field = '';
            }
        },
        continueToBuy(){
            this.steps.orderCompleted = false;
            this.steps.isFirst = true;
            setTimeout(() => this.setSlider(),300);
        },
        goToCheckout(){
            const cartButton = document.getElementsByClassName('cs-header__cartWrapper')[0];
            cartButton.click();
        }
    },
    mounted: function() {
        this.steps.isFirst = false;
        this.steps.isLoading = true;
        // eslint-disable-next-line no-undef
        axios.get(siteURL + '/wp-content/themes/cs-theme/assets/sliders-dictionaries/' + passed_values.cs4_product_dictionary_dir + '/dictionary-' + currentLanguage + '.json').then(
            res => {
                this.dictionary = res.data;
                this.steps.isFirst = true;
                this.steps.isLoading = false;
                this.getProductInfo().then(() => {
                    this.setSlider();
                    this.product.initialUnitPrice = this.getProductPrice(0) / this.getProductQuantity(0);
                });
            }
        )
    },
};
